const getUniqueArrayByKey = (array, key) => {
 return [...new Map(array.map(item => [item[key], item])).values()]
}

export default getUniqueArrayByKey